/**
 * The tone player: a central pulsing motion graphic flanked by −/+ buttons.
 * The rings animate only while the tone is playing.
 */
export function TonePlayer({
  playing,
  onQuieter,
  onLouder,
  canQuieter,
  canLouder,
}: {
  playing: boolean;
  onQuieter: () => void;
  onLouder: () => void;
  canQuieter: boolean;
  canLouder: boolean;
}) {
  return (
    <div className="tone-player">
      <div className="tone-adjust-group">
        <button
          className="tone-adjust"
          onClick={onQuieter}
          disabled={!canQuieter}
          aria-label="Make the tone quieter"
        >
          −
        </button>
        <span className="tone-adjust-label" aria-hidden>
          Quieter
        </span>
      </div>

      <div
        className={"tone-orb" + (playing ? " playing" : "")}
        role="img"
        aria-label={playing ? "Tone is playing" : "Tone is paused"}
      >
        <span className="tone-ring r1" aria-hidden />
        <span className="tone-ring r2" aria-hidden />
        <span className="tone-ring r3" aria-hidden />
        <span className="tone-core" aria-hidden>
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 9v6h4l6 5V4L8 9H4z"
              fill="currentColor"
            />
            <path
              d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </span>
      </div>

      <div className="tone-adjust-group">
        <button
          className="tone-adjust"
          onClick={onLouder}
          disabled={!canLouder}
          aria-label="Make the tone louder"
        >
          +
        </button>
        <span className="tone-adjust-label" aria-hidden>
          Louder
        </span>
      </div>
    </div>
  );
}
